import { OrganizationDetails, Role, InviteMemberPayload } from '../types/organizationTypes';
import {organizationAxiosInstance} from './axiosInstances';
export const organizationService = {

  getOrganizations: async () => {
    try {
      const response = await organizationAxiosInstance.get('/organizations');
      return response.data.organizations || [];
    } catch (error) {
      throw error;
    }
  },

  getInvitations: async (id: string) => {
    try {
      const response = await organizationAxiosInstance.get(`/organizations/${id}/invitations?status=pending`);
      const invitations = response.data.invitations || [];
      return invitations;
    } catch (error) {
      throw error;
    }
  }, 

  getOrganizationById: async (id: string): Promise<OrganizationDetails> => {
    try {
      const response = await organizationAxiosInstance.get(`/organizations/${id}`);
      return response.data.organization;
    } catch (error) {
      throw error;
    }
  },

  getOrganizationMembers: async (id: string, filter?: string): Promise<{ members: any[] }> => {
    try {
      const response = await organizationAxiosInstance.get(`/organizations/${id}/members`,{
        params: { filter }

      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  deleteMember : async (orgId: string, memberId: string): Promise<any> => {
    try {
      const response = await organizationAxiosInstance.delete(
        `/organizations/${orgId}/members/${memberId}`,
      );
      return response.data;
    }
    catch (error) {
      throw error;
    }
  },

  editMemberRoles(orgId: string, memberId: string, roleName: string) {
    return organizationAxiosInstance.post(`/organizations/${orgId}/members/${memberId}/editRoles`, {
        roleName: roleName

    });
},



  removeRoleFromMember(orgId: string, memberId: string, roleName: string) {
      return organizationAxiosInstance.delete(`/organizations/${orgId}/members/${memberId}/deleteRoles`, {
          data: { roleName: roleName }
      });
  },

  getRealmRoles: async (): Promise<Role[]> => {
    try {
      const response = await organizationAxiosInstance.get(`/roles`);
      const roles = response.data.roles;
      return roles
      } catch (error) {
        console.error('Error fetching realm roles:', error);
        return [];
      }
  },
  
  inviteMember: async (payload: InviteMemberPayload): Promise<any> => {
    try {
      const response = await organizationAxiosInstance.post(
        `/organizations/${payload.organizationId}/invite`,
        payload
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  resendInvitation : async (orgId: string, invitationId:string) => {
    try {
      const response = await organizationAxiosInstance.post(
        `/organizations/${orgId}/invitations/${invitationId}/resend-email`,
        
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  getOrganizationOptions:  async () => {
    try {
      const response = await organizationAxiosInstance.get('/organizations');
      const organizations = response.data.organizations || [];
      return organizations.map((org: OrganizationDetails) => ({
        label: org.display_name,
        value: org.id,
        free_trial: org.free_trial
      }));
    } catch (error) {
      throw error;
    }
  },
  
  updateOrganization: async (id: string, payload: { attribute: string , value:any }): Promise<any> => {
    try {
      const response = await organizationAxiosInstance.patch(`/organizations/${id}`, payload);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  fetchDomains: async (orgId: string): Promise<any> => {
    try {
      const response = await organizationAxiosInstance.get(`/organizations/${orgId}/domains`);
      return response.data.domains;
    } catch (error) {
      throw error;
    }
  },

  addNewDomain: async (orgId: string, domainName: string): Promise<any> => {
    try {
      await organizationAxiosInstance.post(`/organizations/${orgId}/add-domain`,{
        domainName
      });
    
    } catch (error) {
      throw error;
    }
  },

  verifyDomain: async (orgId: string, domainName: string, nameServers: string[]): Promise<any> => {
    try {
      const response = await organizationAxiosInstance.post(`/organizations/${orgId}/verify-domain`,{
        domainName,
        nameServers
      });
      
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  deleteDomain: async (orgId: string, domainName: string, hostedZoneId: string): Promise<any> => {
    try {
      await organizationAxiosInstance.delete(`/organizations/${orgId}/delete-domain`,{
        data: {
          domainName,
          hostedZoneId
        }
      });
    
    } catch (error) {
      throw error;
    }
  },
  
  updateFreeTrial: async (organizationId: string, value: boolean) => {
    try {
      await organizationAxiosInstance.patch(`/organizations/${organizationId}/free-trial`, {
        data: {
          type: 'organizations',
          attributes: {
            value: value
          }
        }
      });
    } catch (error) {
      console.error('Error updating free trial status:', error);
      throw error;
    }
  },
  
  updateDomain: async (orgId: string, domainName: string) => {
    try {
      await organizationAxiosInstance.patch(`/organizations/${orgId}/update-domain`,{
        domainName
      });
    
    } catch (error) {
      throw error;
    }
  },
};

export default organizationService;
